import { addDays } from "date-fns/addDays";
import { useCallback, useMemo, useState } from "react";
import { getDateRangeFromFormDates, handleDateRangeCalendarChange, parseFormDateString } from "../shared/utils/form-date.js";
const STAY_SEARCH_CALENDAR_MONTHS = 13;
const DEFAULT_HOTEL_TRAVELERS = {
    adults: 2,
    children: 0,
    childrenAges: {},
    rooms: 1,
    lapInfants: 0
};
function createEmptySelectedTopFilters() {
    return {
        amenities: new Set(),
        hotelStarLevel: new Set(),
        guestRating: new Set(),
        propertyTypes: new Set()
    };
}
const DEFAULT_HOTEL_FORM_STATE = {
    endLocation: null,
    startLocation: null,
    startDate: '',
    endDate: '',
    travelers: DEFAULT_HOTEL_TRAVELERS,
    tripType: 'STAY',
    mapView: false,
    selectedTopFilters: createEmptySelectedTopFilters(),
    petFriendly: false
};
function createRateTableHotelFormState(fixedEndLocation) {
    return {
        ...DEFAULT_HOTEL_FORM_STATE,
        endLocation: fixedEndLocation
    };
}
function getHotelTravelerFieldErrorMessage(travelerErrors) {
    return travelerErrors?.children?.message || travelerErrors?.rooms?.message || '';
}
function toTravelerState(info) {
    return {
        adults: info.adults ?? DEFAULT_HOTEL_TRAVELERS.adults,
        children: info.children ?? DEFAULT_HOTEL_TRAVELERS.children,
        childrenAges: info.childrenAges ?? DEFAULT_HOTEL_TRAVELERS.childrenAges,
        rooms: info.rooms ?? DEFAULT_HOTEL_TRAVELERS.rooms,
        lapInfants: info.lapInfants ?? DEFAULT_HOTEL_TRAVELERS.lapInfants
    };
}
function areTravelerStatesEqual(a, b) {
    if (a.adults !== b.adults || a.children !== b.children || a.rooms !== b.rooms || a.lapInfants !== b.lapInfants) return false;
    const aAges = a.childrenAges;
    const bAges = b.childrenAges;
    const ageKeys = new Set([
        ...Object.keys(aAges),
        ...Object.keys(bAges)
    ]);
    for (const key of ageKeys)if (aAges[Number(key)] !== bAges[Number(key)]) return false;
    return true;
}
function useHotelDateRangeCalendar({ setValue, startDate, endDate }) {
    const [maxSelectableDate, setMaxSelectableDate] = useState();
    const currentDate = useMemo(()=>new Date(), []);
    const initialSelectedDates = useMemo(()=>getDateRangeFromFormDates(startDate, endDate, currentDate), [
        currentDate,
        endDate,
        startDate
    ]);
    const [defaultMonth, setDefaultMonth] = useState(()=>parseFormDateString(startDate, currentDate) ?? currentDate);
    const onCalendarChange = useCallback((dates)=>{
        handleDateRangeCalendarChange(setValue, 'startDate', 'endDate', setDefaultMonth, dates, {
            clearEndDateOnStart: true,
            shouldDirty: true
        });
        dates?.from && dates?.to === void 0 ? setMaxSelectableDate(addDays(dates.from, 28)) : setMaxSelectableDate(void 0);
    }, [
        setValue
    ]);
    const clearMaxSelectableDate = useCallback(()=>{
        setMaxSelectableDate(void 0);
    }, []);
    return {
        currentDate,
        defaultMonth,
        initialSelectedDates,
        maxSelectableDate,
        onCalendarChange,
        clearMaxSelectableDate
    };
}
export { DEFAULT_HOTEL_FORM_STATE, DEFAULT_HOTEL_TRAVELERS, STAY_SEARCH_CALENDAR_MONTHS, areTravelerStatesEqual, createEmptySelectedTopFilters, createRateTableHotelFormState, getHotelTravelerFieldErrorMessage, toTravelerState, useHotelDateRangeCalendar };
